var $1d9a07ba6109b0d9$exports = {};
$1d9a07ba6109b0d9$exports = {
    "collapse": `D\xf6lj`,
    "expand": `Expandera`
};


export {$1d9a07ba6109b0d9$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
